import { Injectable } from '@angular/core';

import {CrudDataGenericService} from '../shared/services';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ProvincesService extends CrudDataGenericService <any> {
  url = '/province/';
  constructor(protected http: HttpClient) {
    super(http);
  }
}



// WEBPACK FOOTER //
// ./src/app/provinces/provinces.service.ts